import { get, patch, type RequestOptions } from '@/api/client';
import type {
  BirdEyeFinishedResponse,
  BirdEyeResponse,
  BirdEyeStatusUpdateResponse,
  BirdEyeVisitStatus,
} from './types';

export const birdEyeApi = {
  getLive: (locationId: number, options?: RequestOptions) =>
    get<BirdEyeResponse>('/api/bird-eye', { location: locationId }, options),
  getFinished: (locationId: number, date?: string, options?: RequestOptions) =>
    get<BirdEyeFinishedResponse>(
      '/api/calendar/bird-eye/finished',
      {
        location: locationId,
        ...(date ? { date } : {}),
      },
      options,
    ),
  updateAppointmentStatus: (
    appointmentId: number,
    status: BirdEyeVisitStatus,
    locationId: number,
  ) =>
    patch<BirdEyeStatusUpdateResponse>(
      `/api/calendar/bird-eye/appointments/${appointmentId}`,
      { status },
      { location: locationId },
    ),
};
